const SIZES = { sm: 'h-9 px-[14px] text-sm', md: 'h-12 px-5 text-catering-base', lg: 'h-14 px-6 text-lg' }

const CATERING_BASE =
  'inline-flex items-center justify-center gap-2 font-catering-body font-semibold leading-none whitespace-nowrap select-none transition-[background,box-shadow,transform,border-color] duration-200 focus:outline-none active:translate-y-px active:scale-[.99]'

const CATERING_VARIANTS = {
  accent:
    'rounded-full border-2 border-catering-ink-900 text-catering-ink-900 bg-catering-lemon shadow-catering-sm hover:bg-catering-lemon-600 hover:shadow-catering-accent',
  ghost: 'rounded-full border-2 border-transparent bg-transparent text-catering-ink-900 hover:bg-catering-cream-300',
  cream:
    'rounded-full border-2 border-catering-cream-500 text-catering-ink-900 bg-catering-cream-50 shadow-catering-xs hover:bg-catering-cream-200 hover:shadow-catering-sm'
}

const CATERING_OFF =
  'rounded-full border-2 border-transparent bg-catering-cream-300 text-catering-ink-400 shadow-none cursor-not-allowed'

// focus-visible, not focus: a modal moves focus to its first button on open,
// and a ring painted around Cancel the moment a dialog appears reads as a
// selection the merchant did not make. Keyboard focus still shows it.
const LEGACY_BASE =
  'transition-all inline-flex items-center rounded-md px-2 py-1 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 hover:transform hover:scale-105 border border-gray-400 shrink-0'

const LEGACY_VARIANTS = {
  primary: 'border-transparent shadow-md shadow-inner text-white bg-gray-brand-700 hover:bg-gray-brand-900',
  secondary: 'border-gray-300 shadow-sm shadow-inner text-gray-700 bg-white hover:bg-gray-50',
  inactive: 'border-transparent text-brand-500 bg-brand-100 cursor-not-allowed',
  red: 'text-red-700 bg-red-100 border-red-300 hover:bg-red-300',
  // Solid counterpart to `red`, for the second press of a confirm-twice action.
  danger: 'border-transparent shadow-md text-white bg-red-600 hover:bg-red-700'
}

export function neueButtonClasses({ type = 'primary', size = 'md', off = false } = {}) {
  if (CATERING_VARIANTS[type]) {
    return [CATERING_BASE, SIZES[size] || SIZES.md, off ? CATERING_OFF : CATERING_VARIANTS[type]].join(' ')
  }
  return [LEGACY_BASE, LEGACY_VARIANTS[type] || LEGACY_VARIANTS.primary].join(' ')
}
